// value constants
export const COLUMNS_SIDEBAR = "columns";
export const EXPOSURE_SIDEBAR = "exposure";
export const SNOWFLAKE_STAGE_SIDEBAR = "snowflake_stage";
export const DASHBOARD_SIDEBAR = "dashboard";
export const FUNCTION_SIDEBAR = "function";
export const TABLES_SIDEBAR = "tables";
export const FEEDBACK_SIDEBAR = "feedback";
export const HELP_SIDEBAR = "help";
export const SETTINGS_SIDEBAR = "settings";

// react flow prefix for node types
export const COLUMN_PREFIX = "column-";
export const SEE_MORE_PREFIX = "see-more-";
